import {
    FETCH_EXPORT_ORDERS_HISTORY_SUCCESS,
    FETCH_EXPORT_ORDER_LAYOUTS_SUCCESS,
    FETCH_NOT_EXPORTED_ORDERS_SUCCESS,
    EXPORT_ORDERS_HISTORY_LOADING,
    NOT_EXPORTED_ORDERS_REQUEST_LOADING,
    EXPORT_ORDERS_REQUEST_ERRORS
} from "api/menu/export/orders/actions";

const initialState = {
    notExportedOrdersLoading: false,
    historyLoading: false,
    errors: [],

    notExportedOrders: [],
    ordersHistory: [],
    orderLayouts: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case EXPORT_ORDERS_HISTORY_LOADING:
            return {
                ...state,
                historyLoading: true
            };
        case NOT_EXPORTED_ORDERS_REQUEST_LOADING:
            return {
                ...state,
                notExportedOrdersLoading: true
            };
        case EXPORT_ORDERS_REQUEST_ERRORS:
            return {
                ...state,
                historyLoading: false,
                notExportedOrdersLoading: false,
                errors: action.payload
            };
        case FETCH_EXPORT_ORDERS_HISTORY_SUCCESS:
            return {
                ...state,
                historyLoading: false,
                ordersHistory: action.payload
            };
        case FETCH_NOT_EXPORTED_ORDERS_SUCCESS:
            return {
                ...state,
                notExportedOrdersLoading: false,
                notExportedOrders: action.payload
            };
        case FETCH_EXPORT_ORDER_LAYOUTS_SUCCESS:
            return {
                ...state,
                orderLayouts: action.payload
            };
        default:
            return state;
    }
}
